import { useTranslation } from "react-i18next";
import { CustomModal } from "../../../components/CustomModal/CustomModal";
import useStyles from "./styles";
import { FC } from "react";
import { CustomTypography } from "../../../components/CustomTypography/CustomTypography";
import { useDeleteSign } from "../../../api/signs";

type ModalDeleteSignProps = {
  open: boolean;
  signInitial: TSign;
  onCancel?: () => void;
  onClose?: () => void;
};

export const ModalDeleteSign: FC<ModalDeleteSignProps> = ({
  open,
  signInitial,
  onCancel,
  onClose,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { mutate: deleteSign, isPending } = useDeleteSign(onClose);

  const onConfirm = () => {
    if (signInitial.id !== -1) {
      deleteSign(signInitial.id);
    }
  };

  return (
    <CustomModal
      open={open}
      onCancel={onCancel}
      title={""}
      onClose={onClose}
      isConfirmation
      textConfirmation={t("common.validate", "Validate")}
      loadingConfirmation={isPending}
      onConfirm={onConfirm}
    >
      <div className={classes.textModalContainer}>
        <CustomTypography
          text={t("sign.deleteSign", {
            name: signInitial?.name,
            defaultValue: `Are you sure you want to delete the sign "${signInitial?.name}"?`
          })}
          variant="default"
        />
      </div>
    </CustomModal>
  );
};